import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function DeployIcon({ ...props }) {
  return (
    <SvgIcon width="55" height="55" viewBox="0 0 55 55" {...props}>
      <path
        d="M45.1236 22.1993C44.4086 13.1478 36.7773 6 27.5 6C19.5643 6 12.7521 11.1287 10.5541 18.6088C4.28411 20.7744 0 26.685 0 33.3636C0 41.9851 7.04982 49 15.7143 49H41.25C48.8321 49 55 42.8627 55 35.3182C55 29.1633 50.9339 23.8802 45.1236 22.1993ZM41.25 45.0909H15.7143C9.21446 45.0909 3.92857 39.8312 3.92857 33.3636C3.92857 28.0629 7.52911 23.4072 12.6834 22.0429C13.3905 21.8553 13.9346 21.2924 14.0957 20.5829C15.4904 14.3987 21.1279 9.90909 27.5 9.90909C34.7561 9.90909 41.2421 15.6242 41.2421 23.7649C41.2421 24.7206 41.9355 25.5357 42.8823 25.692C47.628 26.4836 51.0714 30.5315 51.0714 35.3182C51.0714 40.7069 46.6655 45.0909 41.25 45.0909Z"
        fill="white"
      />
      <path
        d="M36.4429 26.2263C37.1857 26.9758 37.1857 28.1873 36.4429 28.9368C35.7 29.6863 34.4992 29.6863 33.7564 28.9368L29.3999 24.5413V39.0831C29.3999 40.1412 28.5487 41 27.5 41C26.4513 41 25.6001 40.1412 25.6001 39.0831V24.5413L21.2436 28.9368C20.5007 29.6863 19.3 29.6863 18.5571 28.9368C17.8143 28.1873 17.8143 26.9758 18.5571 26.2263L26.1568 18.5585C26.8977 17.8109 28.1099 17.8167 28.8451 18.5585L36.4429 26.2263Z"
        fill="white"
      />
    </SvgIcon>
  );
}
